"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchSaveSetType = void 0;
var SearchSaveSetType;
(function (SearchSaveSetType) {
    SearchSaveSetType.toString = function (saveType) {
        switch (saveType) {
            case SearchSaveSetType.District: return 'district';
            case SearchSaveSetType.District: return 'building';
        }
        return 'property-search';
    };
})(SearchSaveSetType = exports.SearchSaveSetType || (exports.SearchSaveSetType = {}));
(function (SearchSaveSetType) {
    SearchSaveSetType[SearchSaveSetType["Search"] = 1] = "Search";
    SearchSaveSetType[SearchSaveSetType["Building"] = 2] = "Building";
    SearchSaveSetType[SearchSaveSetType["District"] = 3] = "District";
    SearchSaveSetType[SearchSaveSetType["Map"] = 4] = "Map";
    SearchSaveSetType[SearchSaveSetType["Block"] = 5] = "Block";
})(SearchSaveSetType = exports.SearchSaveSetType || (exports.SearchSaveSetType = {}));
